import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';

import cls from 'classnames/bind';

import chunk from 'lodash/chunk';
import noop from 'lodash/noop';

import Loading12p from '@ott/loading12p';

import HotTourCard from './blocks/HotTourCard';
import { getHotTours } from './redux/actions';

import styles from './HotTours.scss';

const cx = cls.bind(styles);

@connect()
class HotTours extends PureComponent {
  static propTypes = {
    hotTours: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)),
    viewportWidth: PropTypes.number,
    showImages: PropTypes.bool,
    trackEvent: PropTypes.func,
  };

  static defaultProps = {
    hotTours: {},
    showImages: false,
    trackEvent: noop,
  };

  state = {
    rowsQuantity: 1,
    slideIndex: 0,
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getHotTours());
  }

  handleMoreClick = () => {
    const { rowsQuantity } = this.state;
    const { trackEvent } = this.props;

    this.setState({ rowsQuantity: rowsQuantity + 1 });

    trackEvent('moreClick');
  };

  renderCardsInContainer() {
    const { rowsQuantity } = this.state;
    const { hotTours, viewportWidth, showImages, trackEvent } = this.props;

    // eslint-disable-next-line no-nested-ternary
    const cardsInRow = viewportWidth < 1024 ? (viewportWidth < 768 ? 1 : 2) : 3;
    const rows = chunk(hotTours.data, cardsInRow);
    const rowsToRender = rows.slice(0, rowsQuantity);

    return (
      <div className={cx('container')}>
        <div className={cx('cards')}>
          {rowsToRender.map((row, i) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <div className={cx('row')} key={i}>
                {row.map((hotTour, index) => {
                  return (
                    <HotTourCard
                      className={cx('card', `card--${cardsInRow}`)}
                      // eslint-disable-next-line react/no-array-index-key
                      key={index}
                      data={hotTour}
                      showImages={showImages}
                      viewportWidth={viewportWidth}
                      trackEvent={trackEvent}
                    />
                  );
                })}
              </div>
            );
          })}
        </div>

        {rowsQuantity < rows.length && (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div className={cx('more')} onClick={this.handleMoreClick}>
            Ещё предложения
          </div>
        )}
      </div>
    );
  }

  handleChangeSlideIndex = (slideIndex) => {
    const { trackEvent } = this.props;

    this.setState({ slideIndex });

    trackEvent('changeSlide');
  };

  renderCardsInSlider() {
    const { slideIndex } = this.state;
    const {
      hotTours: { data: items },
      showImages,
      trackEvent,
      viewportWidth,
    } = this.props;

    return (
      <div className={cx('container')}>
        <SwipeableViews
          index={slideIndex}
          onChangeIndex={this.handleChangeSlideIndex}
          style={{ margin: '0 -16px' }}
          containerStyle={{ width: '100vw' }}
          slideStyle={{ padding: '0 16px 8px', boxSizing: 'border-box' }}
        >
          {items.map((hotTour, i) => {
            return (
              <HotTourCard
                className={cx('card', `card--isMobile`)}
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                data={hotTour}
                hasOverlay={false}
                showImages={showImages}
                viewportWidth={viewportWidth}
                trackEvent={trackEvent}
              />
            );
          })}
        </SwipeableViews>

        <div className={cx('dots')}>
          {items.map((item, i) => {
            return (
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
              <div
                className={cx('dot', {
                  'dot--isActive': i === slideIndex,
                })}
                onClick={this.handleChangeSlideIndex.bind(this, i)}
                // eslint-disable-next-line react/no-array-index-key
                key={i}
              />
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    const { className, hotTours, viewportWidth } = this.props;

    if (!hotTours.success || !hotTours.data.length) {
      return null;
    }

    const showSlider = viewportWidth < 768;

    return (
      <div className={cx('HotTours', className)}>
        {showSlider ? this.renderCardsInSlider() : this.renderCardsInContainer()}

        {hotTours.loading && (
          <div className={cx('loader')}>
            <Loading12p />
          </div>
        )}
      </div>
    );
  }
}

export default HotTours;

export { default as reducer } from './redux';
